export enum PhoneType {
	MobilePhone = 'Celular',
	HomePhone = 'Fijo',
}
